<div class="instructor-cell">
	<lb-user-icon [userID]="instructorUserID()"></lb-user-icon>
	<div class="name-section">
		<span class="name"> {{ instructor() ? instructor()?.firstName + ' ' + instructor()?.lastName : 'N/A' }}</span>
		<span> {{ instructor() ? instructor()?.email : 'N/A' }} </span>
	</div>
</div>
